import React, { useState } from 'react'

export const ThemeContext = React.createContext()

export function ThemeContextProvider (props) {
  const [themeColor, setThemeColor] = useState('linear-gradient(to right, #63D5ED, #6E8FF8)')
  return (
    <ThemeContext.Provider value={{ themeColor, setThemeColor }}>
      {props.children}
    </ThemeContext.Provider>
  )
}
